import axios from "../plugins/parseAxios";
export class MarketAPI {
  constructor(props) { }
  static getMarketByProject(payload, user) {
    return axios.post("functions/getMarketByProject", payload, user);
  }
  static updateImageBase64(payload) {
    return axios.post("functions/updateImageBase64", payload, user);
  }
}
